<template>
  <div class="talent-concept-page">
    <Banner :bannerUrl="bannerUrl" :title="$t('talentConceptPage.bannerTitle')">
      <template  v-slot:content>
        <div class="banner_text">{{ $t('talentConceptPage.bannerText') }}</div>
        <a-button class="banner_btn" type="primary" @click="toJobDetail">{{ $t('talentConceptPage.bannerBtn') }}</a-button>
      </template>
    </Banner>
    <div class="container">
      <h2 class="com-top-tile">{{ $t('talentConceptPage.moduleTitle') }}</h2>
      <p class="title-desc">{{ $t('talentConceptPage.moduleText') }}</p>
      <div class="culture-square fs" :class="{ en: locale === 'en' }">
        <div class="square-item text">
          <div class="title">{{ $t('talentConceptPage.featureTitle1') }}</div>
          <p>{{ $t('talentConceptPage.featureText1') }}</p>
        </div>
        <div class="square-item img">
          <img :src="squreImg1">
        </div>
        <div class="square-item img">
          <img :src="squreImg2">
        </div>
        <div class="square-item text">
          <div class="title">{{ $t('talentConceptPage.featureTitle2') }}</div>
          <p>{{ $t('talentConceptPage.featureText2') }}</p>
        </div>
      </div>
      <div class="join-us">
        <div class="title">{{ $t('talentConceptPage.readTitle') }}</div>
        <a-button class="join-btn" type="primary" size="large" @click="toJobList">{{ $t('talentConceptPage.viewAllJob') }}</a-button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useRouter} from 'vue-router';
  import Banner from '@/components/banner'
  import { useI18n } from "vue-i18n";
const { locale } = useI18n({useScope: "global"})
  const router = useRouter();
  const bannerUrl = require('@assets/images/banner/banner-talent-concept.png');
  const squreImg1 = require('@assets/images/talent_concept_1.png');
  const squreImg2 = require('@assets/images/talent_concept_2.png');

  const toJobDetail = () => {
    router.push({
      name: 'JobDetail'
    })
  }

  const toJobList = () => {
    router.push({
      name: 'JoinUs'
    })
  }
</script>

<style lang="less" scoped>
@media screen and (max-width: 1148px) {
  .container {
    padding: 0 30px;
    .culture-square .square-item {
      width: 100%!important;
    }
  }
}
.talent-concept-page {
  .container {
    max-width: 1148px;
  }
  /deep/ .com-banner {
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(107.44deg, #313445 25.09%, rgba(49, 52, 69, 0) 61.95%);
    }
    .banner_text {
      font-size: 20px;
      font-weight: 600;
      line-height: 46px;
      color: #fff;
    }
    .banner_btn {
      margin-top: 33px;
      width: 122px;
      height: 38px;
      font-size: 14px;
    }
  }
  .com-top-tile {
    margin-top: 80px;
    padding-left: 30px;
  }
  .title-desc {
    font-size: 14px;
    line-height: 180%;
    color: #666C89;
    padding-left: 30px;
    margin-bottom: 29px;
  }
  .culture-square {
    background-color: #E6F4FF;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 96px;
    &.en {
      .square-item.text {
        padding: 15px 25px;
      }
    }
    .square-item {
      width: 50%;
      &.text {
        padding: 58px 25px;
        line-height: 180%;
        .title {
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 11px;
        }
        p {
          font-size: 12px;
          color: #7D7D7D;
        }
      }
      &.img {
        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }
  .join-us {
    text-align: center;
    margin-bottom: 198px;
    .title {
      color: #151E2C;
      font-size: 32px;
      font-weight: 600;
      line-height: 46px;
      margin-bottom: 44px;
    }
    .join-btn {
      width: 100%;
      height: 70px;
      line-height: 70px;
      font-size: 20px;
      line-height: 46px;
      font-weight: 60px;
    }
  }
}
</style>